module.exports = __webpack_public_path__ + "img/4.f832f22d.jpg";